"use client"

import { PanelTopDashed } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PanelTopDashedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PanelTopDashedIcon = component(Icon)({ as: PanelTopDashed })
